import React, { useEffect, useState } from 'react'
import Managebtn from '../../Component/Managebtn'
import Billcnt from '../../Component/Billcnt'
import TimeFrameComp from '../../Component/TimeFrameComp'
import { useNavigate } from 'react-router-dom'
import { useLanguage } from '../../Providers/LanguageContext'

function Index() {
    const [time, setTime] = useState("day")
    const { language } = useLanguage();
    const navigate = useNavigate()
    const getTime = (val) => {
        setTime(val)
    }

    useEffect(() => {
        window.scrollTo({ top: '0', behavior: 'instant' })
    }, [])

    return (

        <>
            {/* <div className='d-flex gap-2 mb-2' style={{ margin: "0 0 0 154px" }}>
                <div className=''>
                    <button className='w-100 btn btn-outline-success' style={{ fontWeight: "bold" }} onClick={() => navigate('/viewexpensedetails')}>{language.view_expense_details}</button>
                </div>

                <div className=''>
                    <button className='w-100 btn btn-outline-success' style={{ fontWeight: "bold" }} onClick={() => navigate('/edit-expense-details')}>
                        {language.edit_exp_detail}
                    </button>
                </div>
            </div> */}
            {/* <div className="try_fisibilty_wrapper " style={{
                transform: 'translateY(0%)',
                margin: '0px',
                justifyContent: 'start',
                background: '#031f31ff'

            }}>
                <div className="container-fluid">
                    <p className="text-left">Expense Manager / Post new expense</p> </div>
            </div> */}
            <div style={{
                background: 'linear-gradient(rgb(15, 36, 55),#fff)',
                padding: '50px 0px'
            }}>
                <div className='container-fluid pt-3'>
                    <div className='task_head'> Post New Expense</div>
                </div>
                <div className='container-fluid mt-3'>
                    <div style={{
                        cursor: 'pointer',
                        display: 'flex',
                        
                        gap: '20px',
                        width:'100%',
                    }} className='col-xl-12 col-lg-12 col-md-12 col-12 navigation_buttons_wrapper'>
                        <button className='slctUser ' style={{
                            background: 'rgb(136, 233, 132)',
                            fontWeight: '500',
                            color: '#0c2637'
                        }} onClick={(() => navigate('/viewexpensedetails'))}>View expense Detail</button>
                        <button className='slctUser ' style={{
                            background: 'rgb(136, 233, 132)',
                            fontWeight: '500',
                            color: '#0c2637'
                        }} onClick={(() => navigate('/edit-expense-details'))}>Edit expense Detail</button>
                    </div>
                    </div>
                <div className='container-fluid' style={{
                    border: '4px solid #fff',
                    borderRadius: '25px',
                    padding: '10px 20px',
                    marginTop: '20px'
                }}>
                    <Managebtn white={true} getTime={getTime} value={time} />

                    <Billcnt time={time} setTime={setTime} />
                </div>

            </div>



        </>
    )
}

export default Index